import React from "react";
import { Box, CardMedia, makeStyles, Typography } from "@material-ui/core";
import photo from "../../../assets/aboutUs/about5.png";

const useStyles = makeStyles(({ breakpoints, spacing, palette }) => ({
  container: {
    display: "grid",
    gridTemplateRows: "100vh",
    gridTemplateColumns: "60% 40%",
    overflow: "hidden",
  },
  text: {
    width: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  paragraph: {
    width: "55%",
    color: "#272727",
    fontWeight: 300,
    fontSize: "16px",
    lineHeight: "18px",
    textAlign: "end",
    margin: `0 ${spacing(3)}px`,
  },
  year: {
    color: "#272727",
    fontWeight: "bold",
    fontSize: "122px",
    lineHeight: "100%",
    margin: `0 ${spacing(3)}px`,
  },
  img: {
    height: "100%",
  },
}));

const about5 = () => {
  const classes = useStyles();

  return (
    <Box component="div" className={classes.container}>
      <Box component="div" className={classes.text}>
        <Typography className={classes.paragraph} p="true">
          Fallece don Manuel Ventura, y la empresa enfrenta un reto grande, ya
          que a pesar de que sus hijas se habían involucrado desde tiempo atrás
          en el negocio, el gremio de velas no está acostumbrado a que la mujer
          tenga presencia en las decisiones administrativas. Sin embargo, poco a
          poco, bajo la enorme influencia que don Manuel tuvo durante años y la
          enseñanza que les brindó sobre el negocio, fueron re-inventando la
          empresa y haciéndose un nombre propio, a la vez que iniciaron alianzas
          estratégicas con nuevos proveedores.
        </Typography>
        <Typography className={classes.year} variant="h3">
          2006
        </Typography>
        <Typography className={classes.paragraph} p="true">
          Gracias al crecimiento del negocio y a la apertura de nuevos mercados,
          se hizo necesario empezar a importar materias primas, mejorando los
          procesos de producción y abriendo nuevas oportunidades de empleo,
          siempre mayormente de las áreas rurales, manteniendo la iniciativa que
          desde sus inicios tuvo la empresa.
        </Typography>
        <Typography className={classes.year} variant="h3">
          2012
        </Typography>
      </Box>
      <Box component="div" className={classes.image}>
        <CardMedia className={classes.img} component="img" image={photo} />
      </Box>
    </Box>
  );
};

export default about5;
